module.exports = __webpack_public_path__ + "media/images/communities/logos/lajc-36bc6895220a57bc47ec5424e69a2dc9.png";